import WindowService from '@src/services/window.service';

export enum ChewyUserAgent {
  IOS = 'chewy-ios',
  ANDROID = 'chewy-android',
}

export type UserAgentType =
  | { userAgent: string; isNma: false; isIOS: false; isAndroid: false }
  | { userAgent: string; isNma: true; isIOS: true; isAndroid: false }
  | { userAgent: string; isNma: true; isIOS: false; isAndroid: true };

export const getUserAgent = (): UserAgentType => {
  const userAgent = WindowService?.window?.navigator?.userAgent;
  const userAgentProduct = userAgent?.split('/')[0] || '';

  if (userAgentProduct === ChewyUserAgent.IOS) {
    return {
      userAgent: userAgent,
      isNma: true,
      isIOS: true,
      isAndroid: false,
    };
  }

  if (userAgentProduct === ChewyUserAgent.ANDROID) {
    return {
      userAgent: userAgent,
      isNma: true,
      isIOS: false,
      isAndroid: true,
    };
  }

  return { userAgent: userAgent, isNma: false, isIOS: false, isAndroid: false };
};
